import React, { lazy } from 'react';
import { roleSet } from 'src/constants/role';
import { NomenclatureValues } from './services';

const NomenclaturePage = lazy(() => import('./NomenclaturePage/'));
const NomenclatureTechCardsPage = lazy(
  () => import('./NomenclatureTechCardsPage/')
);
const NomenclatureBatchesPage = lazy(
  () => import('./NomenclatureBatchesPage/')
);
const NomenclatureCostHistoryPage = lazy(
  () => import('./NomenclatureCostHistoryPage/')
);

export type NomenclatureTab = {
  index?: boolean;
  path?: string;
  element: JSX.Element;
  handle: {
    label: string;
    title: string | ((data: NomenclatureValues) => string);
    showDelete?: boolean;
    disabled?: boolean;
    types?: number[];
    roles?: string[];
    nonFranchiseeAccessOnly?: boolean;
  };
};

export const nomenclaturesTabs: NomenclatureTab[] = [
  {
    index: true,
    element: <NomenclaturePage />,
    handle: {
      label: 'Общие настройки',
      title: 'Редактировать номенклатуру',
      showDelete: true,
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
  },
  {
    path: 'tech-cards',
    element: <NomenclatureTechCardsPage />,
    handle: {
      label: 'ТТК',
      disabled: true,
      title: (data) =>
        `Технологические карты для номенклатуры ${data.shortName || data.name}`,
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
  },
  {
    path: 'batches',
    element: <NomenclatureBatchesPage />,
    handle: {
      label: 'Партии',
      title: (data) => `Партии для номенклатуры ${data.shortName || data.name}`,
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
  },
  {
    path: 'cost-history',
    element: <NomenclatureCostHistoryPage />,
    handle: {
      label: 'История цен',
      title: (data) =>
        `История цен для номенклатуры ${data.shortName || data.name}`,
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
  },
];
